import type { SvgIconProps } from "@mui/material/SvgIcon";
import { Terminal, Upload, User, Workflow, Zap } from "lucide-mui";
import type { ReactElement } from "react";
import type { ProspectHitKind, ProspectSource } from "../../api/client.ts";
import ClaudeLogo from "../ClaudeLogo.tsx";

/** The icon for what prospected a company. */
export function hitKindIcon(kind: ProspectHitKind | ProspectSource["kind"], props?: SvgIconProps): ReactElement {
  switch (kind) {
    case "signal":
      return <Zap {...props} />;
    case "agent":
      return <ClaudeLogo {...props} />;
    case "workflow":
      return <Workflow {...props} />;
    case "bulk_filter":
      return <Upload {...props} />;
    case "mcp":
      return <Terminal {...props} />;
    default:
      return <User {...props} />;
  }
}

export function hitKindLabel(kind: ProspectHitKind | ProspectSource["kind"]): string {
  switch (kind) {
    case "signal":
      return "Signal";
    case "agent":
      return "Prospecting agent";
    case "workflow":
      return "Workflow";
    case "bulk_filter":
      return "Bulk add";
    case "mcp":
      return "MCP";
    default:
      return "Added by hand";
  }
}

/** How a source reads on a chip: "2 signals from Tender watch", "Prospector ×1". */
export function sourceLabel(source: ProspectSource): string {
  if (source.kind === "signal") {
    return `${source.count} signal${source.count === 1 ? "" : "s"}${
      source.workflow_name ? ` · ${source.workflow_name}` : ""
    }`;
  }
  if (source.kind === "agent") return `${source.agent_name ?? "Agent"} ×${source.count}`;
  return `Added by hand ×${source.count}`;
}
